import { useState } from "react";
import {Modal, Button, Container, Row, Col} from "react-bootstrap";
import { ApiBaseUrl } from "../configuration";
import { IImagePayload } from "../dto/IImagePayload";
import {useTranslation} from 'react-i18next';


const ImageModal = (props: {pictureIds: IImagePayload[], table: string}) => {

const pictureIds = props.pictureIds;
const table = props.table;
const [show, setShow] = useState(false);
const [currentPictureIdIndex, setCurrentPictureIdIndex] = useState(0);
const {t} = useTranslation();

function nextImageIdIndex(currentIndex: number) {
    if (currentIndex + 1 < pictureIds.length) {
        setCurrentPictureIdIndex(currentPictureIdIndex + 1)
    }
}

function previousImageIdIndex(currentIndex: number) {
    if (currentIndex - 1 >= 0) {
        setCurrentPictureIdIndex(currentPictureIdIndex - 1)
    }
}


function getUIStringForTable() {
    switch (table) {
        case "pan": { return t('modalPanorama'); }
        case "sidemed": { return t('modalBlueprint'); }
        case "tuupjoonis": { return t('modalMarkerType'); }
        case "pilt": { return t('modalPictures'); }
        default: { return "NA"; }
      }
}

function getTimeString(time: Date) {
    let convertedTime = new Date(time);
    //const options: DateTimeFormatOptions = {year: "numeric", month: "2-digit", day: "2-digit"};
    let returnString = "";
    if (time !== null) {
        if (convertedTime.getHours() === 0 && convertedTime.getMinutes() === 0 && convertedTime.getSeconds() === 0) {
            returnString = convertedTime.toLocaleDateString(t('modalLocale').toString(), {year: "numeric", month: "2-digit", day: "2-digit"});
        } else {
            returnString = convertedTime.toLocaleString(t('modalLocale').toString(), {year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit"});
        }
    }
    return returnString;
}

return (
    <>
        <Button className="me-2" onClick={() => setShow(true)}>
            {getUIStringForTable()}
        </Button>

        <Modal show={show} size="lg" onHide={() => setShow(false)}>
            <Modal.Header closeButton>
            <Modal.Title>{getUIStringForTable()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <Container>
                    <Row>
                        <Col md="auto" className="d-flex align-items-center justify-content-center">
                            <Button variant={(currentPictureIdIndex - 1 >= 0) ? "primary" : "secondary"} disabled={currentPictureIdIndex - 1 < 0} onClick={() => previousImageIdIndex(currentPictureIdIndex)}>
                                {`<`}
                            </Button>
                        </Col>
                        <Col className="text-center">
                            {getTimeString(pictureIds[currentPictureIdIndex].time)}<br />
                            <img alt={pictureIds[currentPictureIdIndex].toString()} className='img-fluid' src={ApiBaseUrl + "/image/" + table + "/" + pictureIds[currentPictureIdIndex].id} /><br />
                            {currentPictureIdIndex + 1} / {pictureIds.length}
                        </Col>
                        <Col md="auto" className="d-flex align-items-center justify-content-center">
                            <Button variant={(currentPictureIdIndex + 1 < pictureIds.length) ? "primary" : "secondary"}  disabled={currentPictureIdIndex + 1 >= pictureIds.length} onClick={() => nextImageIdIndex(currentPictureIdIndex)}>
                                {`>`}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            
             
            
            </Modal.Body>
        </Modal>
    </>

)

}

export default ImageModal;